export const Colors = { green: "#36CF6F" }
